<script>
import selaImage from '@/assets/sela2bcloud.png'

export default {
    name: 'StaticPopup',
    props: {
        readMoreUrl: { type: String, default: 'https://selacloud.com/insights/sela-and-2bcloud-join-forces-to-build-the-1-cloud-services-organization-for-the-ai-economy' },
        readMoreText: { type: String, default: 'Read More' },
        showOnce: { type: Boolean, default: true },
        storageId: { type: String, default: 'staticPopupShown' },
        imageUrl: { type: String, default: () => selaImage }
    },
    data() {
        return {
            visible: false
        }
    },
    methods: {
        close() {
            this.visible = false
            if (this.showOnce) {
                try {
                    localStorage.setItem(this.storageId, '1')
                } catch (e) {
                    // ignore storage errors
                }
            }
        },
        handleOverlayClick(e) {
            if (e.target === e.currentTarget) this.close()
        },
        onKeydown(e) {
            if (e.key === 'Escape') this.close()
        }
    },
    mounted() {
        if (this.showOnce) {
            try {
                const seen = localStorage.getItem(this.storageId)
                if (seen === null) this.visible = true
            } catch (e) {
                this.visible = true
            }
        } else {
            this.visible = true
        }
        if (this.visible === true) {
            console.log('Popup shown')
        } else {
            console.log('Popup ignored')
        }
        if (this.visible) window.addEventListener('keydown', this.onKeydown)
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeydown)
    },
    watch: {
        visible(v) {
            if (v) window.addEventListener('keydown', this.onKeydown)
            else window.removeEventListener('keydown', this.onKeydown)
        }
    }
}
</script>

<template>
    <div v-if="visible" class="static-popup-backdrop" @click="handleOverlayClick" >
        <div class="static-popup" role="dialog" aria-modal="true">
			<div class="static-popup-content">
				<div v-if="imageUrl" class="static-popup-image">
					<img :src="imageUrl" alt="Popup image">
				</div>
				<div class="text-margins">
					<strong>Sela & 2bcloud: Building the #1 Cloud Organization for the AI Era</strong>
				</div>
				<p>We are excited to announce that 2bcloud is officially joining the Sela family!</p>
				<p class="text-margins">
					This merger creates a global multi-cloud powerhouse with over 400 engineers and
					premier partnerships across AWS, Azure, and Google Cloud. By combining our
					strengths, we're doubling down on our mission to provide the scale, speed, and
					engineering precision the new AI economy demands.
				</p>

				<div class="static-popup-actions">
					<a :href="readMoreUrl" class="btn btn-read-more" @click="close">{{ readMoreText }}</a>
					<button class="btn btn-dismiss" @click="close">
						Dismiss
					</button>
				</div>
			</div>
        </div>
    </div>
</template>

<style scoped>
/* backdrop */
.static-popup-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1200;
    padding: 16px;
}

.static-popup {
    background: #fff;
    border-radius: 10px;
    width: 100%;
    max-width: 720px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    position: relative;
    padding: 24px;
    max-height: 90vh;
    overflow: auto;
}

.static-popup-close {
    position: absolute;
    top: 8px;
    right: 8px;
    border: none;
    background: transparent;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
}

.static-popup-content {
    font-size: 16px;
    color: #111;
    line-height: 1.4;
}

.static-popup-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 20px;
}

.btn {
    padding: 10px 14px;
    border-radius: 6px;
    border: 1px solid transparent;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
}

.btn-read-more {
    background: transparent;
    color: var(--bgl-blue-dark, #0b63ce);
    border-color: rgba(11, 99, 206, 0.12);
}

.btn-dismiss {
    background: var(--bgl-gray, #f3f3f3);
    color: #111;
    border-color: rgba(0, 0, 0, 0.06);
}

.text-margins {
    display: block;
    padding-top: 12px;
    padding-bottom: 12px;
}

/* Responsive adjustments */
@media (max-width: 480px) {
    .static-popup {
        padding: 16px;
        max-width: 420px;
    }

    .static-popup-content {
        font-size: 15px;
    }
}

@media (min-width: 1024px) {
    .static-popup {
        padding: 28px;
    }
}
</style>
